import * as React from "react";

const baseClass = "rj-slim-progressbar";
export class SlimProgressbar extends React.Component<{
    eventID: string
}, {}> {

    render() {
        return (
            <div id={`pipe-${this.props.eventID}`} className={baseClass}>
                <div className={`${baseClass}__separator`}></div>
                <div className={`${baseClass}__pipe`}>
                    {this.props.children}
                </div>
            </div >
        )
    }
}